import NetPayTable from './Table';
import styles from './index.module.scss';

type NetPayProps = {
	selectedPayrollId: string;
	headerData: any;
	setTotalNetPay: any;
	setIsUniversalLoading: any;
	totalNetPay: any;
	setIsNegative: any;
	showSteps: boolean;
	onlyView: boolean;
};

const NetPayComponent = (props: NetPayProps) => {
	const {
		selectedPayrollId,
		headerData,
		setTotalNetPay,
		setIsUniversalLoading,
		totalNetPay,
		setIsNegative,
		showSteps,
		onlyView,
	} = props;
	return (
		<div className={styles['work-hours__table']}>
			<NetPayTable
				selectedPayrollId={selectedPayrollId}
				setTotalNetPay={setTotalNetPay}
				setIsUniversalLoading={setIsUniversalLoading}
				headerData={headerData}
				totalNetPay={totalNetPay}
				setIsNegative={setIsNegative}
				showSteps={showSteps}
				onlyView={onlyView}
			/>
		</div>
	);
};

export default NetPayComponent;
